<template>
  <div>
    <div class="generic-fullscreen">
      <LightBox
        :media="mediaImages"
        :showCaption="true"
        :disableScroll="false"
        :showThumbs="showThumbsValue"
        :nThumbs="numberOfThumbs"
        :showLightBox="false"
        ref="fancyImages"
      ></LightBox>
    </div>

    <section class="media-center">
      <div class="container">
        <div class="row">
          <div
            class="col-md-4"
            v-bind:key="index"
            v-for="(item, index) in imgGalleryData"
          >
            <div class="generic-card">
              <div class="generic-card-link">
                <div class="card-img card-img-details">
                  <img
                    :src="item.PhotoCardsListUrl"
                    alt="card image"
                    @error="replaceByDefaultImg"
                  />
                  <div
                    class="card-thumbnail"
                    v-on:click="openImageFullScreen(index)"
                  >
                    <i class="icon-expand"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="generic-error-message" v-show="showNoDataMessage">
          <p class="message-text"><span>Sorry! </span>No results were found.</p>
        </div>
        <div class="generic-loader" v-show="isAjaxLoading">
          <img src="../../../../src/assets/spinner.svg" alt="EDA Spinner" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import LightBox from "vue-image-lightbox";
import VueLazyLoad from "vue-lazyload";
import Vue from "vue";
Vue.use(VueLazyLoad);
import axios from "axios";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";

let contactApiUrl;
let listingThis;

export default {
  props: {
    Title: {
      type: String,
    },
    Brief: {
      type: String,
    },
    GalleryId: {
      type: Number,
    },
  },
  components: {
    LightBox,
  },
  data() {
    return {
      imgGalleryData: [],
      tempImages: [],
      scrollCount: 1,
      mediaImages: [],
      showNoDataMessage: false,
      isthierMoreData: true,
      isAjaxLoading: false,
      showThumbsValue: true,
      numberOfThumbs: 6,
    };
  },
  methods: {
    getData() {
      listingThis.isAjaxLoading = true;
      contactApiUrl = `/Umbraco/surface/PhotoGalleries/GetGalleryPhotos?requiredPage=${listingThis.scrollCount}&contentId=${listingThis.GalleryId}`;

      axios
        .get(contactApiUrl, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        })
        .then(function(response) {
          if (response.data != "") {
            listingThis.showNoDataMessage = false;
            if (listingThis.scrollCount == 1) {
              listingThis.imgGalleryData = response.data;
            } else {
              listingThis.imgGalleryData = listingThis.imgGalleryData.concat(
                response.data
              );
            }
          } else {
            listingThis.isthierMoreData = false;
            if (listingThis.scrollCount == 1) {
              listingThis.imgGalleryData = [];
              listingThis.showNoDataMessage = true;
            }
          }
          listingThis.isAjaxLoading = false;
        });
    },
    replaceByDefaultImg(e) {
      e.target.src = "../../../../src/assets/default.png";
    },
    openImageFullScreen: function(index) {
      listingThis.tempImages = [];
      listingThis.mediaImages = [];
      listingThis.tempImages = listingThis.imgGalleryData;
      if (listingThis.tempImages.length != 0) {
        for (let i = 0; i < listingThis.tempImages.length; i++) {
          listingThis.mediaImages.push({
            src: listingThis.tempImages[i].PhotoCenteredUrl,
            thumb: listingThis.tempImages[i].PhotoCarouselCenteredUrl,
          });
        }
        if (listingThis.tempImages.length == 1) {
          listingThis.showThumbsValue = false;
        } else {
          listingThis.showThumbsValue = true;
        }
        setTimeout(function() {
          listingThis.$refs.fancyImages.showImage(index);
        }, 100);
      }
    },
  },
  mounted() {
    listingThis = this;
    listingThis.getData();

    let observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !listingThis.isAjaxLoading &&
          listingThis.isthierMoreData
        ) {
          listingThis.scrollCount++;
          listingThis.getData();
        }
      });
    });

    //this is make cause footer content is loaded late so it's positions changed
    setTimeout(function() {
      const container = document.querySelector(".footer");
      observer.observe(container);
    }, 100);
  },
};
</script>
